<template>
  <div :class="format == 'col-12' ? 'row' : 'form-group ' + format">
    <template v-if="format != 'col-12'">
      <label :for="label" class="form-label">{{
        label == null
          ? parameter == "start_date"
            ? "Mulai Tanggal"
            : parameter == "end_date"
            ? "Sampai Tanggal"
            : label
          : label
      }}</label>
      <input
        type="date"
        class="form-control"
        v-model="model[parameter]"
        :disabled="disabled"
      />
    </template>
    <template v-else>
      <div class="form-group" :class="format">
        <label :for="label" class="form-label">{{
          label == null
            ? parameter == "start_date"
              ? "Mulai Tanggal"
              : parameter == "end_date"
              ? "Sampai Tanggal"
              : label
            : label
        }}</label>
        <input
          type="date"
          class="form-control"
          v-model="model[parameter]"
          :disabled="disabled"
        />
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    model: { default: null },
    label: { default: null },
    format: { default: "col-12" },
    disabled: { default: false },
    parameter: { default: "start_date" },
  },
  methods: {},
  mounted() {},
};
</script>